import React, {Fragment, Component } from 'react'
import store from '../store'
import Adsimple from '../components/adsimple'

class Product extends Component{
  constructor(props){
    super(props);
    this.state = store.getState();
    this.handleStoreChange = this.handleStoreChange.bind(this);
    store.subscribe(this.handleStoreChange);
  }
  render(){
    return(
      <Fragment>
        {this.state.products.map((item,index)=>{
          return <Adsimple picsrc={item} link={'/product/'+index} key={index} />
        })}
      </Fragment>
    )
  }
  handleStoreChange() {
    this.setState(store.getState());
  }
}
export default Product;